import { useState } from 'react'
import { FeedingType } from './feedingContent'

export const useCurrentlyFeedingModule = () => {
  const [selectedFeeding, setSelectedFeeding] = useState<FeedingType | null>(null)
  const [isMobilePanelOpen, setIsMobilePanelOpen] = useState(false)

  const selectFeeding = (type: FeedingType) =>
    setSelectedFeeding((current) => (current === type ? null : type))

  const toggleMobilePanel = () =>
    setIsMobilePanelOpen((open) => {
      const next = !open
      if (!next) setSelectedFeeding(null)
      return next
    })

  const closeMobilePanel = () => {
    setIsMobilePanelOpen(false)
    setSelectedFeeding(null)
  }

  return {
    selectedFeeding,
    isMobilePanelOpen,
    selectFeeding,
    toggleMobilePanel,
    closeMobilePanel,
  }
}
